export class FullStretch extends HTMLElement {
	public static createFullStretch(doc: Document): FullStretch {
		return doc.createElement("full-stretch");
	}
}
